import React from 'react';
import { Head } from '@inertiajs/react';
import CategoryList from '@/components/admin/blog/CategoryList';

interface Category {
  id: number;
  name: string;
  slug: string;
  description: string;
  post_count: number;
  created_at: string;
  updated_at: string;
}

interface Props {
  categories: Category[];
}

const Index: React.FC<Props> = ({ categories }) => {
  return (
    <>
      <Head title="Blog Categories" />
      <CategoryList categories={categories} canCreate={true} canEdit={true} canDelete={false} />
    </>
  );
};

export default Index;
